import "./App.css";
import Main from "./Components/Main";

function App() {
  return (
    <div className="App flex center">
      <Main />
    </div>
  );
}

export default App;
